import type { Hours, OpenHours } from 'app/types/entities'

export type DayKey = keyof OpenHours

const DEFAULT_HOURS: Hours = { from: `10:00`, to: `18:00` }

export const defaultOpenHours: OpenHours = {
  sunday: { hours: [{ ...DEFAULT_HOURS }], open: false },
  monday: { hours: [{ ...DEFAULT_HOURS }], open: true },
  tuesday: { hours: [{ ...DEFAULT_HOURS }], open: true },
  wednesday: { hours: [{ ...DEFAULT_HOURS }], open: true },
  thursday: { hours: [{ ...DEFAULT_HOURS }], open: true },
  friday: { hours: [{ ...DEFAULT_HOURS }], open: true },
  saturday: { hours: [{ ...DEFAULT_HOURS }], open: false },
}

/**
 * Hours used to seed a newly added time slot for a day. When `seedHours` has a
 * range for that day (e.g. the location's business hours), the new slot copies
 * it; otherwise it falls back to the standard 10:00–18:00 default.
 */
export function newSlotFromSeed(seedHours: OpenHours | undefined, day: DayKey): Hours {
  const seed = seedHours?.[day]?.hours?.[0]
  return seed ? { from: seed.from, to: seed.to } : { ...DEFAULT_HOURS }
}
